import { DatePickerCustom, InputNumber, Loading, Modal, TableCustom } from "../../common"
import { getDateToString, getFormatNumber, getNumeroRecibo_ObjectToString } from "../../../utils/convert"
import { useEffect, useState } from "react"
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { useEntidad, useForm, useLista } from "../../hooks"
import { ServerRequest } from "../../../utils/apiweb"
import { APIS } from "../../../config/apis"
import NumeroCuentaField from "../NumeroCuentaField"


const CuentaPagoDetalleModal = ({ id, onCancel }) => {

    const [apertura, setApertura] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if ((id ?? 0) > 0) {
            FindCuentaPagoById();
        }
    }, [id]);

    const [, getRowLista] = useLista({
        listas: ['TipoTributo'],
        memo: {
          key: 'TipoTributo',
          timeout: 0
        }
    });

    const [, getRowEntidad] = useEntidad({
        entidades: ['TipoMovimiento', 'Tasa', 'SubTasa'],
        memo: null
    });

    const [formValues, , , formSet] = useForm({
        codigoTipoTributo: '',
        idTipoTributo: 0,
        idTributo: 0,
        numeroCuenta: '',
        codigoDelegacion: '',
        numeroRecibo: 0,
        importeVencimiento1: 0,
        importeVencimiento2: 0,
        fechaVencimiento1: null,
        fechaVencimiento2: null,
        fechaCobro: null
    });

    const callbackNoSuccess = (response) => {
        response.json()
            .then((error) => {
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error.message);
                setLoading(false);
            })
            .catch((error) => {
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, 'Error procesando respuesta: ' + error);
                setLoading(false);
            });
    }

    const callbackError = (error) => {
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, 'Error procesando solicitud: ' + error.message);
        setLoading(false);
    }

    const callbackSuccess = (response) => {
        response.json()
            .then((cuentaPago) => {
                setLoading(false);
                setApertura(cuentaPago.cuentaPagoItem ?? []);
                formSet({
                    codigoTipoTributo: cuentaPago.codigoTipoTributo ?? '',
                    idTipoTributo: cuentaPago.idTipoTributo ?? 0,
                    idTributo: cuentaPago.idTributo ?? 0,
                    numeroCuenta: cuentaPago.numeroCuenta ?? '',
                    codigoDelegacion: cuentaPago.codigoDelegacion,
                    numeroRecibo: cuentaPago.numeroRecibo,
                    importeVencimiento1: cuentaPago.importeVencimiento1,
                    importeVencimiento2: cuentaPago.importeVencimiento2,
                    fechaVencimiento1: cuentaPago.fechaVencimiento1 ? new Date(cuentaPago.fechaVencimiento1) : null,
                    fechaVencimiento2: cuentaPago.fechaVencimiento2 ? new Date(cuentaPago.fechaVencimiento2) : null,
                    fechaCobro: cuentaPago.fechaCobro ? new Date(cuentaPago.fechaCobro) : null,
                });
            })
            .catch((error) => {
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, 'Error procesando respuesta: ' + error);
                setLoading(false);
            });
    };

    function FindCuentaPagoById() {
        setLoading(true);
        const paramsUrl = `/detalle/${id}`;

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.CUENTA_PAGO,
            paramsUrl,
            null,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );
    }

    const getNombreTipoTributo = (idTipoTributo) => {
        const row = getRowLista('TipoTributo', idTipoTributo);
        return row ? row.nombre : "";
    }

    const getNombreTipoMovimiento = (idTipoMovimiento) => {
        const row = getRowEntidad('TipoMovimiento', idTipoMovimiento);
        return row ? row.nombre : "";
    }

    const getDescTasa = (idTasa) => {
        const row = getRowEntidad('Tasa', idTasa);
        return row ? `${row.codigo} - ${row.descripcion}` : "";
    }

    const getDescSubTasa = (idSubTasa) => {
        const row = getRowEntidad('SubTasa', idSubTasa);
        return row ? `${row.codigo} - ${row.descripcion}` : "";
    }

    return (
        <Modal
            size="xl"
            onEscape={onCancel}
            title={`VEP ${getNumeroRecibo_ObjectToString(formValues)}`}
            body={(
                <>
                    <Loading visible={loading}></Loading>

                    <div className="row">
                        <div className="mb-3 col-12 col-lg-2">
                            <label htmlFor="idTipoTributo" className="form-label">Tipo tributo</label>
                            <input
                                name="idTipoTributo"
                                type="text"
                                className="form-control"
                                value={getNombreTipoTributo(formValues.idTipoTributo)}
                                disabled={true}
                            />
                        </div>

                        <div className="mb-3 col-12 col-lg-2">
                            <label htmlFor="numeroCuenta" className="form-label">Número cuenta</label>
                            <NumeroCuentaField
                                numeroCuenta={formValues.numeroCuenta}
                                idTributo={formValues.idTributo}
                                idTipoTributo={formValues.idTipoTributo}
                                onNavigate={onCancel}
                            />
                        </div>

                        <div className="mb-3 col-12 col-lg-2">
                            <label htmlFor="estado" className="form-label">Estado</label>
                            <input
                                name="estado"
                                type="text"
                                className="form-control"
                                value={formValues.fechaCobro ? 'Pago' : 'No pago'}
                                disabled={true}
                            />
                        </div>

                        <div className="mb-3 col-12 col-lg-2">
                            <label htmlFor="fechaCobro" className="form-label">Fecha de pago</label>
                            <input
                                name="fechaCobro"
                                type="text"
                                className="form-control"
                                value={formValues.fechaCobro ? getDateToString(formValues.fechaCobro) : '-'}
                                disabled={true}
                            />
                        </div>

                        <div className="mb-3 col-12 col-lg-2">
                            <label htmlFor="importeVencimiento1" className="form-label">Importe 1° Vto.</label>
                            <InputNumber
                                name="importeVencimiento1"
                                className="form-control"
                                precision={2}
                                value={formValues.importeVencimiento1}
                                disabled={true}
                            />
                        </div>

                         <div className="mb-3 col-12 col-lg-2">
                            <label htmlFor="importeVencimiento2" className="form-label">Importe 2° Vto.</label>
                            <InputNumber
                                name="importeVencimiento2"
                                className="form-control"
                                precision={2}
                                value={formValues.importeVencimiento2}
                                disabled={true}
                            />
                        </div>

                        <div className="mb-3 col-12 col-lg-2">
                            <label htmlFor="fechaVencimiento1" className="form-label">Fecha 1° Vto.</label>
                            <DatePickerCustom
                                name="fechaVencimiento1"
                                className="form-control"
                                value={ formValues.fechaVencimiento1 }
                                disabled={true}
                            />
                        </div>

                        <div className="mb-3 col-12 col-lg-2">
                            <label htmlFor="fechaVencimiento2" className="form-label">Fecha 2° Vto.</label>
                            <DatePickerCustom
                                name="fechaVencimiento2"
                                className="form-control"
                                value={ formValues.fechaVencimiento2 }
                                disabled={true}
                            />
                        </div>
                    </div>

                    <label className="form-label m-top-10">Apertura de tasas</label>
                    <TableCustom
                        className={'TableCustomBase m-top-5'}
                        data={apertura}
                        columns={[
                            { Header: 'Tasa', id: 'tasa', accessor: row => getDescTasa(row.idTasa), width: '11%' },
                            { Header: 'Sub tasa', id: 'subTasa', accessor: row => getDescSubTasa(row.idSubTasa), width: '14%' },
                            { Header: 'Tipo movimiento', id: 'tipoMovimiento', accessor: row => getNombreTipoMovimiento(row.idTipoMovimiento), width: '14%', alignCell: 'right' },
                            { Header: 'Período', accessor: 'periodo', width: '8%' },
                            { Header: 'Cuota', accessor: 'cuota', width: '7%' },
                            { Header: 'Importe', Cell: (data) => getFormatNumber(data.value, 2), accessor: 'importeTotal', width: '8%', alignCell: 'right' },
                            { Header: 'Fecha Vto.', Cell: (data) => getDateToString(data.value, false), accessor: 'fechaVencimientoTermino', width: '13%' },
                        ]}
                    />
                </>
            )}
            footer={(
                <div className="width-100p disp-b">
                    <button className="btn back-button m-left-5" data-dismiss="modal" onClick={onCancel}>Volver</button>
                </div>
            )}
        />
    )
}

export default CuentaPagoDetalleModal
